import React, { useEffect, useState } from "react"
import styled from "styled-components"
import useTranslationHook, {
  englishLanguage,
} from "../../../hooks/use-translation.hook"
const DropdownLanguage = styled.div`
  font-family: Facto;
  position: relative;
  z-index: 1;
  grid-area: Language;
  width: fit-content;
`
export const InvinsibleBackdrop = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: transparent;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
`

const DropdownSwitcher = styled.div`
  position: absolute;
  top: 100%;
  border: 1px solid #bbb;
  z-index: 2000;
  background-color: white;
  min-width: 230px;
  cursor: pointer;
`

const DropdownLabel = styled.div<{ active?: boolean }>`
  padding: 0.2rem 0 0 1rem;
  min-width: max-content;
  min-height: max-content;
  display: flex;
  cursor: pointer;
  align-items: center;
  ::after {
    content: "";
    width: 3px;
    height: 3px;
    border: solid #666;
    border-width: 0 1px 1px 0;
    display: inline-block;
    padding: 1px;
    margin-left: 3px;
    transform: ${(props) =>
      props.active ? "rotate(-135deg)" : "rotate(45deg)"};
  }
`

const LanguageList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  margin-top: 4px;
  box-shadow: 0 3px 3px rgb(0 0 0 / 15%);
`

const LanguageItem = styled(DropdownLabel)`
  ::after {
    display: none;
  }
`

const DropdownLabelText = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: black;
  padding: 8px;
  line-height: 20px;
`

const DropdownItemText = styled(DropdownLabelText)`
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 2px;
`

const CountryIcon = styled.img`
  width: 1.5rem;
`

const LanguagePicker = () => {
  const [active, setActive] = useState(false)
  const { language, translationOptions, changeLanguageManually } =
    useTranslationHook()
  const [currentLang, setCurrentLang] = useState(translationOptions[0])

  const setLanguage = (value: string) => {
    changeLanguageManually(value)
  }

  useEffect(() => {
    setActive(false)
    setCurrentLang(
      translationOptions.find(({ value }) => {
        return value === language
      }) || englishLanguage
    )
  }, [language, translationOptions])

  return (
    <DropdownLanguage>
      <DropdownLabel active={active} onClick={() => setActive((prev) => !prev)}>
        <CountryIcon src={currentLang.image.src} alt={currentLang.image.alt} />
        <DropdownLabelText>{currentLang.label}</DropdownLabelText>
      </DropdownLabel>
      {active && (
        <>
          <DropdownSwitcher>
            <LanguageList>
              {translationOptions.map(({ image, label, value }) => (
                <LanguageItem key={value} onClick={() => setLanguage(value)}>
                  <CountryIcon src={image.src} alt={image.alt} />
                  <DropdownItemText>{label}</DropdownItemText>
                </LanguageItem>
              ))}
            </LanguageList>
          </DropdownSwitcher>
          <InvinsibleBackdrop onClick={() => setActive(false)} />
        </>
      )}
    </DropdownLanguage>
  )
}

export default LanguagePicker
